import { render, staticRenderFns } from "./CalendarTypeTabs.vue?vue&type=template&id=06d246d3&"
import script from "./CalendarTypeTabs.vue?vue&type=script&lang=js&"
export * from "./CalendarTypeTabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports